<template>
<template v-if="!isDictEx() || hasWordTasks()">
  <h3 :class='["ex-header", (exerciseItem.progress_status === "in_progress") && "in-progress", (exerciseItem.progress_status === "completed") && "completed"]'
    @click="open">
    <template v-if="isDictEx()">
      Упражнение
    </template>
    <template v-if="!isDictEx()">
      Упражнение {{ exerciseItem.level_mark }}.{{ exerciseItem.sub_level_mark }}.{{ exerciseIndex+1 }} {{ exerciseItem.name }}
    </template>
    <span class="open-symbol">
      {{ openSymbol }}
    </span>
  </h3>
<!--  <p v-if="exerciseItem.progress_status === 'forbidden'" class="ex-forbidden-moto">-->
<!--    (Пока закрыто, пройдите предыдущие упражнения)-->
<!--  </p>-->
  <!-- <div class="say-moto" v-if="opened">
    Важно сначала всегда произносить ответ вслух, даже если у вас не работает распознавание речи, и только потом печатать ответ, 
    если разпознавание работает некорректно. Это очень сильно влияет на прогресс в изучении языка.<br/>
    Просто смотри на русское слово и вдумчиво заменяй его английским, все слова расположены по порядку, как в английском предложении.
  </div> -->
  <div :class='["editor", "wrap", "editor-ex", "editor-ex-"+exerciseId, (couldProceed || (!showCheckBtn && !showNextBtn)) && "task-success"]' v-if="opened">
    <div v-if="passedSentences.length > 0" class="passed">
      <div v-for="(item, idx) in passedSentences" class="coin-row">
        <div>
          <template v-if="item.file.length > 0">
            <span class="play_audio_file" @click="play(item.file)" v-html="item.sentence"></span>
          </template>
          <template v-else>
            <span class="not-play" v-html="item.sentence"></span>
          </template>
        </div>
      </div>
    </div>
    <div class="task-head-tools">
      <div>
        <div class="task-notice">
<!--          <span class="el-hinted hint&#45;&#45;top hint-rounded hint-medium" aria-label="Если очки кончились, просто заново пройди любые задания на текущем или предыдущем подуровне.">?</span>-->
          Проговорите или напишите фразу по английски "<span class="task-notice-sentence" v-html="prepareTaskView(currentQuestion.task)"></span>"
        </div>
      </div>
    </div>
    <div class="aligned">
      <div class="task">
        <div class="task-text" v-html="prepareTaskView(currentQuestion.task)"></div>
      </div>
      <div class="task-dash">
        <div class="dash"></div>
      </div>
      <div class="output">
        <div class="out-text">
          <template v-if="output.length == 0"><pre>      </pre></template>
          <template v-if="playPhraseLink.length > 0">
            <span class="play_audio_file main-phrase" @click="playPhrase"></span>
          </template>
          <template v-for="(item, itemIdx) in output">
            <template v-if="item.hided">
              <span :class='[item.success && "word-success", item.strikeout && "word-strikeout", "word-hided"]' 
              @click.prevent="showHintBtn(getClearWordIndex(output, idx = itemIdx)); getHint()" v-html="prepareHideWord(item.word)"></span>
            </template>
            <template v-else>
              <span :class='[item.success && "word-success", item.strikeout && "word-strikeout"]'>{{ item.word + " " }}</span>
            </template>
          </template>
        </div>
      </div> 
<!--      <div class="task-hint" v-if="isShowHintBtn">-->
<!--        <button :class='["button input-btn", load && "load-process" ]' -->
<!--        @click.prevent="getHint(); load = true;">Открыть слово</button>-->
<!--      </div>-->

      <template v-if="!couldProceed">
        <div v-if="hasSpeechRecognition()" :class='["speech-wrap", speechActive && "speech-active", !isOnMicroMode && "none"]'>
          <canvas :id="'speech_canvas_'+exerciseId"></canvas>
          <button type="button" :id="'record'+exerciseId" :class="[commonRecordDisabled && 'record-disabled']">
            <span class="pulse-button__rings"></span>
            <span class="pulse-button__rings"></span>
            <span class="pulse-button__rings"></span>
          </button>
        </div>
        <div v-else-if="!hasSpeechRecognition()" class="speech-wrap speech-not-supported">
          Распознавание речи не поддерживается, пожалуйста, используйте браузер Google Chrome
        </div>
      </template>
      <template v-else>
        <div class="check-btns additional-btns">
          <button v-if="showNextBtn" :class='["button input-btn next-btn funny-btn btns", load && "load-process" ]' @click="nextQuestion">Далее</button>
          <button v-if="!showCheckBtn && !showNextBtn" :class='["button input-btn funny-btn start-again-btn btns" ]' @click="startAgain($event);">Пройти заново</button>
        </div>
      </template>


      <textarea :class='[!isOnKeyboardMode && "none"]' name="exercise_answer" id="exercise-answer" autocomplete="answer-ex" :disabled="inputDisabled" class="input" v-model="input" ref="exerciseInput" readonly
      onfocus="this.removeAttribute('readonly')"
        @keydown.enter.exact.prevent
        @keydown.enter.exact="update($event); load = true"
        @keydown.enter.shift.exact="newline"
        @keydown.space.shift="playRecognizer"
        @keydown.tab.prevent="nextQuestion"
      ></textarea>
      <div v-if="speechAttempts > 3" class="speech-attempts-print">
        Вы попытались сказать упражнение более 4 раз, возможно, стоит ввести ответ вручную.
      </div>

      <div class="task-mark-bar">
        <template v-for="(q, qIndex) in ex.tasks">
          <div class="q-mark" :class='["q-mark", q.result && "success", !q.result && "fail", currentQuestionIdx == qIndex && "current" ]'></div>
        </template>
      </div>

      <div class="ex-footer-wrap">
        <div class="switch-wrap mode-wrap-1">
          <span class="voice-text">Выберите режим: </span>
          <div class="mode-wrap" :class="{ on: isOnVoiceMode }">
            <div class="micro" :class="{ on: isOnMicroMode }" @click="switchMicroMode">
              <div class="mode-img"></div>
            </div>
            <div class="keyboard" :class="{ on: isOnKeyboardMode }" @click="switchKeyboardMode">
              <div class="mode-img"></div>
            </div>
          </div>
        </div>

        <div class="check-btns">
          <button v-if="showCheckBtn" :class='["button input-btn btns", load && "load-process" ]' @click="update($event); load = true;">Проверить</button>
          <button v-if="showNextBtn" :class='["button input-btn next-btn funny-btn btns", load && "load-process" ]' @click="nextQuestion">Далее</button>
          <button v-if="!showCheckBtn && !showNextBtn" :class='["button input-btn funny-btn start-again-btn btns" ]' @click="startAgain($event);">Пройти заново</button>
        </div>


        <div class="switch-wrap mode-wrap-2">
          <span class="voice-text">Выберите режим: </span>
          <div class="mode-wrap" :class="{ on: isOnVoiceMode }">
            <div class="micro" :class="{ on: isOnMicroMode }" @click="switchMicroMode">
              <div class="mode-img"></div>
            </div>
            <div class="keyboard" :class="{ on: isOnKeyboardMode }" @click="switchKeyboardMode">
              <div class="mode-img"></div>
            </div>
          </div>
        </div>

        <div class="switch-wrap">
          <span class="voice-text">Выберите сложность: </span><span v-html="voiceMode"></span>
          <div class="switch" :class="{ on: isOnVoiceMode }" @click="toggleSwitchVoiceMode">
            <div class="toggle"></div>
          </div>
        </div>
      </div>


    </div>
  </div>
  <div class="ex-line"></div>
</template>
</template>

<script>
import { debounce } from "lodash-es";
import exerciseClient from "@/client/exercise.js";
import WordsHelper from "@/client/wordsHelper.js";
import MobileDetect from 'mobile-detect';
import { nextTick } from 'vue';
import fileHelper from "@/utils/files";
import progress from "@/progress/progress";
import { MediaRecorder, register } from 'extendable-media-recorder';
import { connect, isSupported } from 'extendable-media-recorder-wav-encoder';

const md = new MobileDetect(window.navigator.userAgent);

connect().then(port => {
  register(port).catch(err => console.log("media recorder register err: ", err))
}).catch()

let speechSupported = true

isSupported().then(supported => speechSupported = supported).catch()

export default {
  props: {
    exerciseId: Number,
    exerciseIndex: Number,
    exerciseItem: Object,
    word: String,
    wordTasks: Array,
    defaultOpen: Boolean,
    voiceSelected: Object,
    voiceRate: Number,
  },
  emits: ['exCompleted', 'startAgain'],
  data: () => ({
    ex: {},
    opened: false,
    inited: false,
    openSymbol: "→",
    input: "",
    output: [],
    load: false,
    currentQuestionIdx: -1,
    currentQuestion: {},
    showCheckBtn: true,
    showNextBtn: false,
    couldProceed: false,
    inputDisabled: false,
    playPhraseLink: '',
    prevTasks: [],
    speechActive: false,
    moneyFile: '/content/money',
    passedSentences: [],

    speechBlocked: false,
    commonRecord: {},
    commonRecordDisabled: false,
    commonRecognizer: {},
    isShowHintBtn: false,
    hintWordIdx: -1,
    speechAttempts: 0,
    audioBlob: {},
    supported: speechSupported,
    isOnVoiceMode: true,
    voiceMode: "Легко",
    audioWithDelay: false,
    isOnMicroMode: true,
    isOnKeyboardMode: false,
    inputCheckedCounter: 0,
    globalRecorder: null,
  }),
  mounted() {
    if (this.exerciseItem.progress_status === "in_progress" || this.defaultOpen) {
      this.open();
    }

    if (localStorage.getItem('voiceMode') !== 'Y' && localStorage.getItem('voiceMode') !== null) {
      this.isOnVoiceMode = false
      this.voiceMode = "Норма"
    }
  },
  methods: {
    switchMicroMode() {
      this.isOnMicroMode = !this.isOnMicroMode
    },
    switchKeyboardMode() {
      this.isOnKeyboardMode = !this.isOnKeyboardMode
    },
    prepareHideWord(word) {
      return word.replace(/•/g, '<span class="hidden-symbol">?</span>');
    },
    prepareTaskView(input) {
      const delimiter = "//"; // Разделитель

      if (!input.includes(delimiter)) {
        return input; // Если разделителя нет, возвращаем строку без изменений
      }

      // Классы для каждого цвета
      const classes = ['cl-1', 'cl-2', 'cl-3', 'cl-4', 'cl-1', 'cl-2', 'cl-3', 'cl-4', 'cl-1', 'cl-2', 'cl-3', 'cl-4'];

      // Разбиваем строку
      const parts = input.split(delimiter);

      // Создаем строки, оборачивая их в <span> с классами
      const result = parts
          .map((part, index) => `<span class="${classes[index % classes.length]}">${part}</span>`)
          .join('');

      return result;
    },
    startAgain() {
      this.$emit('startAgain', {
        exId: this.exerciseId,
      })
    },
    toggleSwitchVoiceMode() {
        this.isOnVoiceMode = !this.isOnVoiceMode;

        if (!this.isOnVoiceMode) {
          this.voiceMode = "Норма"
          localStorage.setItem('voiceMode', '');
        } else {
          this.voiceMode = "Легко"
          localStorage.setItem('voiceMode', 'Y');
        }
    },
    hasWordTasks() {
      return this.isDictEx() && this.wordTasks !== undefined && this.wordTasks.length > 0;
    },
    isDictEx() {
      return this.word !== undefined;
    },
    showHintBtn(itemIdx) {
      this.isShowHintBtn = true
      this.hintWordIdx = itemIdx
    },
    resetHint() {
      this.isShowHintBtn = false
      this.hintWordIdx = -1
    },
    getClearWordIndex(output, index) {
      let res = 0

      for (let i = 0; i < index; i++) {
        if (!output[i].strikeout) {
          res++
        }
      }

      return res
    },
    getHint() {
      if (!this.isDictEx()) {
        let userProgress = progress.GetProgress()

        exerciseClient.GetWordHint(this.exerciseId, this.hintWordIdx, 
          this.currentQuestion.task, userProgress.Score, data => {
          this.resetHint()
          this.load = false

          progress.SetProgress(
            userProgress.LevelMark,
            userProgress.SubLevelMark,
            userProgress.ExMainSort,
            userProgress.SublevelId,
            data.score,
          )

          if (data.exceeded) {
            this.passedSentences.push({
              sentence: '<span class="el-hinted hint--top hint-rounded hint--fit" aria-label="Если очки кончились, просто заново пройди любые задания на текущем или предыдущем подуровне.">'+data.word+'</span>'+ " <b>"+data.score+" <span class='point-star'></span></b>",
              file: '',
            });
          } else {
            this.passedSentences.push({
              sentence: data.word + " <b>"+data.score+" <span class='point-star'></span></b>",
              file: '',
            });
          }
        }, error => {
          this.load = false
        })
      } else {
        WordsHelper.GetWordHintWordSentence(this.word, this.hintWordIdx, 
          this.currentQuestion.task, data => {
          this.resetHint()
          this.load = false

          this.passedSentences.push({
            sentence: data.word,
            file: '',
          });
        }, error => {
          this.load = false
        })
      }
    },
    hasSpeechRecognition() {
      return this.supported
    },
    isYaBrowser(){
      var ua = navigator.userAgent;    
      if (ua.search(/YaBrowser/) > 0) return true;
      return false;
    },
    thenStopRecorder(blob) {
        let file = new File([blob], 'recording.wav');

        this.audioBlob = file
        this.update()
        this.speechAttempts++
    },
    initRecognizer() {
      const record = document.querySelector('#record'+this.exerciseId)
      const canvas = document.getElementById('speech_canvas_'+this.exerciseId);
      const ctx = canvas.getContext('2d');

      if (record !== null) {
        let mediaRecorder = {}
        let animationId;

        const silencePauseDuration = 2500; // Длительность паузы
        const silenceThreshold = 0.35; // Порог громкости для тишины (0.0 - 1.0)

        let analyser;
        let audioContext;
        let silenceTimeout;
        let dataArray;

        record.onclick = e => {
            if (this.speechBlocked || this.load) {
              return
            }

            if (!this.speechActive) {
              navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
                audioContext = new (window.AudioContext || window.webkitAudioContext)();
                analyser = audioContext.createAnalyser();

                // Функция для визуализации
                async function draw() {
                  const microphone = audioContext.createMediaStreamSource(stream);

                  // Соединяем микрофон с анализатором
                  microphone.connect(analyser);
                  analyser.fftSize = 512; // Размер FFT (преобразование Фурье)

                  const bufferLength = analyser.frequencyBinCount;
                  dataArray = new Uint8Array(bufferLength);

                  animationId = requestAnimationFrame(draw);
                  analyser.getByteFrequencyData(dataArray);

                  // Очищаем canvas
                  // ctx.fillStyle = 'rgb(200, 200, 200)';
                  ctx.clearRect(0, 0, canvas.width, canvas.height);

                  // Устанавливаем цвета для каждого диапазона частот
                  const barWidth = (canvas.width / bufferLength) * 2.5;
                  let barHeight;
                  let x = 0;

                  for (let i = 0; i < bufferLength; i++) {
                      barHeight = dataArray[i] / 255 * canvas.height;

                      // Рисуем бары
                      // ctx.fillStyle = `rgb(${barHeight + 100}, 49, 0)`;
                      ctx.fillStyle = `rgb(0, 87, 255)`;
                      ctx.fillRect(x, canvas.height - barHeight, barWidth, barHeight);

                      x += barWidth + 1;
                  }
                }

                draw();

                mediaRecorder = new MediaRecorder(stream, { mimeType: 'audio/wav' });
                this.globalRecorder = mediaRecorder

                let audioChunks = [];

                mediaRecorder.ondataavailable = e => audioChunks.push(e.data);

                mediaRecorder.start();
                checkSilence();
                let recorderTimeout = setTimeout(() => {
                  mediaRecorder.stop()
                  this.speechActive = false
                }, 20000);

                mediaRecorder.onstop = () => {
                  this.globalRecorder = null

                  clearTimeout(recorderTimeout);
                  if (silenceTimeout) {
                    clearTimeout(silenceTimeout);
                    silenceTimeout = null;
                  }

                  if (animationId) {
                      cancelAnimationFrame(animationId);
                  }
                  if (audioContext && audioContext.state !== 'closed') {
                      audioContext.close();
                  }
                  ctx.clearRect(0, 0, canvas.width, canvas.height);

                  // record.style.backgroundColor = "#ff6440"
                  this.speechActive = false

                  record.disabled = false;
                  this.commonRecordDisabled = false

                  let stopTracks = async () => {
                    stream.getAudioTracks().forEach(function(track) {
                      track.stop();
                    });
                  }
                  stopTracks()

                  const audioBlob = new Blob(audioChunks);

                  this.thenStopRecorder(audioBlob)
                };

                // if (!this.speechActive) {
                //   this.speechActive = true
                // } else {
                //   this.speechActive = false
                //
                //   mediaRecorder.stop();
                // }

              }).catch(console.error);
            }

            if (!this.speechActive) {
              this.speechActive = true
            } else {
              this.speechActive = false

              mediaRecorder.stop();
            }

            this.commonRecord = record
            this.commonRecognizer = mediaRecorder
        }

        async function checkSilence() {
          analyser.getByteFrequencyData(dataArray);
          const maxVolume = Math.max(...dataArray) / 256; // Нормируем громкость (0 - 1)

          if (maxVolume < silenceThreshold) {
              // Если тишина, устанавливаем таймер
              if (!silenceTimeout) {
                  silenceTimeout = setTimeout(() => {
                      // console.log('Тишина обнаружена! Останавливаем запись.');
                      stopRecording();
                  }, silencePauseDuration);
              }
          } else {
              // Если звук обнаружен, сбрасываем таймер
              if (silenceTimeout) {
                  clearTimeout(silenceTimeout);
                  silenceTimeout = null;
              }
          }

          // Продолжаем проверку
          if (mediaRecorder && mediaRecorder.state === 'recording') {
              requestAnimationFrame(checkSilence);
          }
        }

        function stopRecording() {
          if (silenceTimeout) {
            clearTimeout(silenceTimeout);
            silenceTimeout = null;
          }

          if (mediaRecorder && mediaRecorder.state === 'recording') {
              mediaRecorder.stop(); // Останавливаем запись
          }
        }
      }
      
      return

      // if (this.hasSpeechRecognition()) {
      //   let recognizer = {}

      //   if (window.webkitSpeechRecognition !== undefined ) {
      //     recognizer = new webkitSpeechRecognition();

      //   } else if (window.SpeechRecognition !== undefined) {
      //     recognizer = new SpeechRecognition();
      //   }

      //   recognizer.interimResults = true;
      //   recognizer.lang = 'en-En';

      //   const record = document.querySelector('#record'+this.exerciseId)

      //   if (record !== null) {
      //     record.onclick = e => {
      //       if (this.speechBlocked || this.load) {
      //         return
      //       }

      //       if (!this.speechActive) {
      //         record.style.backgroundColor = "#0074a6"
      //         this.speechActive = true
      //         recognizer.start();
      //       } else {
      //         record.style.backgroundColor = "#ff6440"
      //         this.speechActive = false
      //         recognizer.stop();
      //       }
      //     }

      //     recognizer.onresult = (event) => {
      //       var result = event.results[event.resultIndex];

      //       if (result.isFinal) {
      //         record.disabled = false;
      //         record.style.backgroundColor = "#ff6440"
      //         this.speechActive = false

      //         if (result[0].transcript != '') {
      //           this.input = result[0].transcript
      //           this.update()
      //           this.speechAttempts++
      //         }

      //         recognizer.stop();
      //       }
      //     };

      //     recognizer.onend = (event) => {
      //       record.style.backgroundColor = "#ff6440"
      //       this.speechActive = false
      //       recognizer.stop();
      //     }

      //     this.commonRecord = record
      //     this.commonRecognizer = recognizer
      //   }
      // }
    },
    playRecognizer() {
      if (!this.speechActive) {
        // this.commonRecord.style.backgroundColor = "#0074a6"
        this.speechActive = true
        this.commonRecognizer.start();
      } else {
        // this.commonRecord.style.backgroundColor = "#ff6440"
        this.speechActive = false
        this.commonRecognizer.stop();
      }
    },
    playPhrase() {
      fileHelper.playAudioFile(this.playPhraseLink, this.audioWithDelay);
    },
    playPhraseWithDelay() {
      fileHelper.playAudioFile(this.playPhraseLink, true);
    },
    play(phrase) {
      fileHelper.playAudioFile(phrase);
    },
    playMainPhraseAsClick() {
      this.audioWithDelay = true
      document.querySelector(".editor-ex-"+this.exerciseId+" .main-phrase").click();
      this.audioWithDelay = false
    },
    newline() {
      this.value = `${this.value}\n`;
    },
    init(callback) {
      const callbackFunc = () => {
        callback()
        let tempProceed = this.couldProceed
        this.couldProceed = true
        if (this.currentQuestionIdx === -1) {
          this.nextQuestion()
        }
        this.couldProceed = tempProceed
      }

      if (!this.isDictEx()) {
        exerciseClient.ExerciseGetById(this.exerciseId, data => {
          this.ex = data
          this.ex.tasks = this.ex.ex_scheme.tasks

          callbackFunc()
        })
      } else {
        this.ex.tasks = this.wordTasks
        callbackFunc()
      }

      
    },
    open() {
      if (this.exerciseItem.progress_status === 'forbidden') {
        return
      }
      if (this.opened === false) {
        if (!this.inited) {
          this.init(() => {
            this.opened = true
            this.openSymbol = "↑"
            this.inited = true
            this.passedSentences = []
            nextTick(() => {
              this.initRecognizer()
            });
          })
        } else {
          this.opened = true
          this.openSymbol = "↑"
          nextTick(() => {
            this.initRecognizer()
          });
        }
      } else {
        this.opened = false
        this.openSymbol = "→"
      }
    },
    update: debounce(function (e) {
      if (this.globalRecorder) {
        this.globalRecorder.stop()
      } else {
        if (this.input.length > 0 || this.audioBlob.size > 100) {
          this.validateEx(this.input)
        }

        this.load = false
      }
    }, 100),
    forceUpdate() {
      this.validateEx(this.input)
      this.load = false
    },
    validateEx(userInput) {
      this.resetHint()
      this.commonRecord.disabled = true
      this.commonRecordDisabled = true
      let userProgress = progress.GetProgress()

      const dataFunc = data => {
        this.inputCheckedCounter++;

        if (this.inputCheckedCounter > 1) {
          this.isOnKeyboardMode = true;
        }

        this.output = data.task_result.word_results
        this.couldProceed = data.task_result.success
        this.currentQuestion.result = data.task_result.success

        this.input = data.task_result.input
        userInput = data.task_result.input
        this.audioBlob = {}
        this.commonRecord.disabled = false
        this.commonRecordDisabled = false

        if (data.ex_completed) {
          this.exerciseItem.progress_status = "completed"

          if (!this.isDictEx()) {
            progress.SetProgress(
              data.next_progress_point.level_mark,
              data.next_progress_point.sub_level_mark,
              data.next_progress_point.ex_main_sort,
              data.next_progress_point.sub_level_id,
              data.score,
            )

            this.$emit('exCompleted', {
              exId: this.exerciseItem.id,
              nextLevelMark: data.next_progress_point.level_mark,
              nextMainSort: data.next_progress_point.ex_main_sort,
            })
          }
          
          this.couldProceed = false
          this.inputDisabled = true
          this.showCheckBtn = false
          this.playPhraseLink = this.currentQuestion.file
          this.currentQuestionIdx++
          this.speechBlocked = true

          if (this.playPhraseLink !== "") {
            nextTick(() => {
              this.playMainPhraseAsClick()
            });
          } else {
            let ut = new SpeechSynthesisUtterance(data.task_result.sentence)
            let lang = 'en-US';
            let voices = window.speechSynthesis.getVoices();
            const selectedVoice = voices.find(voice => voice.lang === lang);
            if (selectedVoice) {
              ut.voice = selectedVoice;
            } else {
              ut.lang = 'en-GB';
            }

            if (this.voiceSelected) {
              ut.voice = this.voiceSelected;
            }
            if (this.voiceRate) {
              ut.rate = this.voiceRate;
            }
            // ut.addEventListener("end", (event) => {
            //   fileHelper.playAudioFile(this.moneyFile);
            // })
            speechSynthesis.speak(ut);
          }

          if (!this.isDictEx()) {
            this.passedSentences.push({
              sentence: data.task_result.sentence + " <b>"+data.score+" <span class='point-star'></span></b>",
              file: this.currentQuestion.file,
            });
          } else {
            this.passedSentences.push({
              sentence: data.task_result.sentence,
              file: this.currentQuestion.file,
            });
          }
        }

        this.showNextBtn = false
        if (this.couldProceed) {
          this.showNextBtn = true
          this.inputDisabled = true
          this.showCheckBtn = false
          this.speechBlocked = true
          if (this.prevTasks.length == 0 || this.prevTasks[this.prevTasks.length-1].task !== this.currentQuestion.task) {
            this.prevTasks.push({
              task: this.currentQuestion.task,
              user_input: userInput,
            })
          }
          this.playPhraseLink = this.currentQuestion.file

          if (!this.isDictEx()) {
            progress.SetProgress(
              userProgress.LevelMark,
              userProgress.SubLevelMark,
              userProgress.ExMainSort,
              userProgress.SublevelId,
              data.score,
            )
          }

          if (this.playPhraseLink !== "") {
            nextTick(() => {
              this.playMainPhraseAsClick()
            });
          } else {
            let ut = new SpeechSynthesisUtterance(data.task_result.sentence)
            let lang = 'en-US';
            let voices = window.speechSynthesis.getVoices();
            const selectedVoice = voices.find(voice => voice.lang === lang);
            if (selectedVoice) {
              ut.voice = selectedVoice;
            } else {
              ut.lang = 'en-GB';
            }

            if (this.voiceSelected) {
              ut.voice = this.voiceSelected;
            }
            if (this.voiceRate) {
              ut.rate = this.voiceRate;
            }
            // ut.addEventListener("end", (event) => {
            //   fileHelper.playAudioFile(this.moneyFile);
            // })
            speechSynthesis.speak(ut);
          }

          if (!this.isDictEx()) {
            this.passedSentences.push({
              sentence: data.task_result.sentence + " <b>"+data.score+" <span class='point-star'></span></b>",
              file: this.currentQuestion.file,
            });
          } else {
            this.passedSentences.push({
              sentence: data.task_result.sentence,
              file: this.currentQuestion.file,
            });
          }
        }
      }

      const errFunc = err => {
        this.audioBlob = {}
        this.commonRecord.disabled = false
        this.commonRecordDisabled = false
      }

      if (!this.isDictEx()) {
        exerciseClient.CheckSentence(this.exerciseId, this.prevTasks, this.currentQuestion.task, userInput, 
          this.audioBlob, userProgress.Score, this.isOnVoiceMode, dataFunc, errFunc)
      } else {
        WordsHelper.CheckWordSentence(this.word, this.currentQuestion.task, this.currentQuestionIdx+1, userInput, 
          this.audioBlob, this.isOnVoiceMode, dataFunc, errFunc)
      }
      
    },
    nextQuestion() {
      if (!this.couldProceed) {
        return
      }

      this.currentQuestionIdx++

      if (this.currentQuestionIdx >= this.ex.tasks.length) {
        return
      }
      
      this.speechAttempts = 0
      this.inputCheckedCounter = 0
      this.currentQuestion = this.ex.tasks[this.currentQuestionIdx]
      this.input = ""
      this.output = []
      this.couldProceed = false
      this.showCheckBtn = true
      this.speechBlocked = false
      nextTick(() => {
        this.initRecognizer()
      });
      this.showNextBtn = false
      this.inputDisabled = false
      this.playPhraseLink = false
      this.forceUpdate()

      if (this.currentQuestionIdx !== 0 && md.mobile() === null) {
        nextTick(() => {
          this.$refs.exerciseInput.focus()
        });
      }
    }
  },
};
</script>

<style scoped>
.task-notice {
  font-size: 18px;
  line-height: 150%;

  .task-notice-sentence {
    color: #0057FF;
  }
}

.task-dash{
  margin-top: 10px;
  margin-bottom: 7px;

  .dash {
    height: 1px;
    width: 30px;
    border-bottom: 1px solid;
  }
}

.check-btns {
  display: flex;
  flex-direction: row;
  align-items: center;

  button {
    margin: 0 auto;
  }
}

.task-hint {
  button {
    margin: 0 auto;
    margin-top: 15px;
    margin-bottom: 30px;
  }
}

.completed {
  button {
    margin: 0 auto;
  }
}

.ex-line {
  width: 100%;
  border-bottom: 2px solid #0057FF;
  margin-top: 15px;
  margin-bottom: 25px;
}

.ex-header {
  text-align: left;
  cursor: pointer;
  color: #4B4B4B;
  font-family: var(--second-family);
  margin: 30px 0 15px 0;
  font-size: 30px;

  .open-symbol {
    /*font-size: 25px;*/
    padding-right: 10px;
    position: static;
  }

  &:before {
    content: url('~@/assets/images/lock.svg');
  }

  &.completed {
    color: #4cb45f;
    &:before {
      content: '✓';
    }
  }

  &.in-progress {
    color: #0057FF;
    &:before {
      content: '↵';
      top: 3px;
      position: relative;
    }
  }
}
.input {
  width: 100%;
  height: 150px;
  border: 3px solid #ff5a2a;
  border-radius: 4px;
  padding: 15px;
  box-sizing: border-box;
  font-size: 22px;
  margin-bottom: 20px;
}
.task-success {
  .input {
    border: 3px solid #6dc304;
  }
  .check-btns.additional-btns {
    margin-bottom: 20px;
  }
}
.input-btn {
  display: block;
  min-width: 100px;
  margin: 30px 30px;

  &.none {
    display: none;
  }

  box-shadow: 0 4px 8px rgba(8, 6, 28, .3);
  font-weight: 500;
  border: 1px solid transparent;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 1.28px;
  cursor: pointer;
  transition: all .2s ease;
}
.funny-btn {
    background-color: #5ba600;
  }
.load-process {
  background-color: #00B2FF;
}
.wrap {
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 0px 20px;
}
.aligned {
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
}
textarea:focus, input:focus{
  outline: none;
}
.output {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  vertical-align: middle;
  font-size: 20px;
  text-align: center;

  .out-text {
    margin-bottom: 20px;
    color: #FF3100;
    line-height: 150%;

    pre {
      margin: 0 !important
    }
  }

  .word-strikeout {
    text-decoration: line-through;
  }

  span:not(.word-success,.word-strikeout,.word-hided) {
    margin: 0 3px;

  }

  span.play_audio_file {
    margin-left: -20px;
  }

  .word-success {
    color: #0057FF;
  }

  .word-hided {
    cursor: pointer;
    border: 2px solid rgba(255, 0, 0, 0);
    -webkit-background-clip: padding-box; /* for Safari */
    background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */
    padding: 2px;
    white-space: nowrap;

    &:hover {
      border: 2px solid #FF3100;
    }
  }
}
.task {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  vertical-align: middle;
  margin-top: 20px;
  font-size: 18px;

  .task-text {
    margin-top: 20px;
    padding: 0px 15px;
    font-size: 20px;
    text-align: center;
    line-height: 150%;
  }
}
.task-head-tools {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.task-mark-bar {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-bottom: 20px;
  margin-right: 5px;

  .q-mark {
    margin-left: 5px;
    width: 18px;
    height: 18px;
    border-radius: 2px;
  }
  .q-mark.success {
    background-color: #6dc304;
  }
  .q-mark.fail {
    background-color: #ff5a2a;
  }
  .q-mark.current {
    background-color: #0057ff;
  }
}

canvas {
  width: 130px;
  height: 40px;
  z-index: 1;
  position: absolute;
  bottom: 0;
}

.speech-wrap {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-bottom: 20px;

  &.none {
    display: none;
  }

  &.speech-not-supported {
    color: #ff6440;
    font-size: 18px;
    padding: 20px;
  }

  button {
    z-index: 100;
    border-radius: 20px;
    border: none;
    cursor: pointer;
    position: relative;
    width: 58px;
    height: 58px;
    padding: 0;
    background: url("@/assets/images/micro.svg") no-repeat;
    background-size: contain;
  }

  &.speech-active {
    .pulse-button__rings {
      border: 1px solid #ff6440;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      height: auto;
      width: auto;
      border-radius: 20px;
      animation-duration: 2.0s;
      animation-name: pulse_1;
      animation-iteration-count: infinite;
      z-index: -1;
    }
    
    .pulse-button__rings:nth-child(2) {
      animation-name: pulse_2;
    }
    
    .pulse-button__rings:nth-child(3) {
      animation-name: pulse_3;
    }

    button {
      background: url("@/assets/images/micro-active.svg") no-repeat;
    }
  }
}

.passed {
  width: 100%;
  font-size: 18px;
  text-align: left;
  color: #0074a6 !important;
  margin-top: 10px;

  .play_audio_file {
    color: rgb(15, 15, 15) !important;
  }
}

/* @keyframes shadow {
  0% {
    box-shadow: 0 0 10px 0px #0074a6, 0 0 10px 0px #0074a6;
  }
  100% {
    box-shadow: 0 0 18px 6px rgba(255, 48, 26, 0), 0 0 4px 50px rgba(255, 48, 26, 0);
  }
} */

@keyframes pulse_1 {
  from {
    opacity: 1;
    transform: scale(0.9, 0.9);
  }
 
  to {
    opacity: 0;
    transform: scale(1.3, 1.3);
  }
}
 
@keyframes pulse_2 {
  from {
    opacity: 1;
    transform: scale(0.8, 0.8);
  }
 
  to {
    opacity: 0;
    transform: scale(1.5, 1.5);
  }
}
 
@keyframes pulse_3 {
  from {
    opacity: 1;
    transform: scale(0.8, 0.8);
  }
 
  to {
    opacity: 0;
    transform: scale(1.7, 1.7);
  }
}

.coin-row {
  display: flex;
  height: auto;
  color: rgb(15, 15, 15);
  line-height: 150%;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 15px;

  .not-play {
    display: block;

    b {
      white-space: nowrap;
    }
  }

  .play_audio_file {
    b {
      white-space: nowrap;
    }
  }
}

.coin{
	background: #ffbd0b;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	position: relative;
  -webkit-transform-style: preserve-3d;
	animation: spin 2s linear infinite;
  top: 12px;
    margin-right: 5px;
}

@keyframes spin{
  0%{
    transform: rotateY(0deg);
  }
  100%{
    transform: rotateY(360deg);
  }
}

.say-moto {
  padding: 20px;
  color: #5ba601;
  padding-top: 0px;
  text-align: center;
}

.editor-ex {
  text-indent: 0px;
  max-width: 1000px;
  margin: 0 auto;
}

.task-hint {
  .input-btn {
    margin-top: 0;
  }
}

.completed {
  color: #5ba600;
}

.speech-attempts-print {
  color: #0057ff;
}

.record-disabled {
  position: relative;
  &::before {
    content: 'загрузка';
    font-size: 17px;
    font-weight: 700;
    color: #0057ff;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1000;
    top: 0;
    left: -4px;
    border-radius: 20px;
    line-height: 60px;
  }
}

.ex-forbidden-moto {
  text-align: left;
}

.switch-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  color: #ff5a2a;
  span {
    padding-right: 7px;
  }

  .voice-text {
    color: rgb(15,15,15);
    line-height: 130%;
  }
}

.mode-wrap {
  display: flex;
  flex-direction: row;

  .micro {
    cursor: pointer;
    width: 50px;
    height: 50px;
    border: 1px solid rgb(15,15,15);
    padding: 10px;
    border-radius: 2px;
    margin-right: 10px;

    .mode-img {
      width: 31px;
      height: 31px;
      background: url("@/assets/images/mode-micro.svg");
      background-repeat: no-repeat;
      background-size: contain;
      margin: 0 auto;


    }

    &.on {
      .mode-img {
        background: url("@/assets/images/mode-micro-active.svg");
      }
    }
  }

  .keyboard {
    cursor: pointer;
    width: 50px;
    height: 50px;
    border: 1px solid rgb(15,15,15);
    padding: 7px;
    border-radius: 2px;
    margin-right: 10px;

    .mode-img {
      width: 34px;
      height: 34px;
      background: url("@/assets/images/mode-keyboard.svg");
      background-repeat: no-repeat;
      background-size: contain;
      margin: 0 auto;
    }

    &.on {
      .mode-img {
        background: url("@/assets/images/mode-keyboard-active.svg");
      }
    }
  }
}

.ex-footer-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  .mode-wrap-2 {
    display: none;
  }

  @media (max-width: 960px) {
    flex-direction: column;
    align-items: normal;

    .mode-wrap-1 {
      display: none;
    }

    .mode-wrap-2 {
      display: flex;
      margin-bottom: 15px;
    }

    .check-btns {
      button {
        margin-bottom: 20px;
      }
    }
  }
}

</style>
